export function numberToCurrency(value: number, withSymbol: boolean = false) {
  const money = (value * 1)
    .toFixed(2)
    .replace('.', ',')
    .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.')
  return (withSymbol ? `R$ ${money}` : money).toString()
}
